import React from 'react';

const Version = () => {

  return (
    <div>
      <p>20260922.0</p>
    </div>
  );
};

export default Version;
